import LazyVideo from "@/components/LazyVideo";

const VideoQuoteSection = () => {
  return (
    <>
      <LazyVideo
        src="/hand-writing-02.mp4"
        className="relative w-full overflow-hidden border-y border-white"
        style={{ aspectRatio: "4/1" }}
      />

      {/* Makineta video */}
      <LazyVideo
        src="/Thinking_in_a_line_makineta_01.mp4"
        className="relative w-full overflow-hidden border-y border-white"
        style={{ aspectRatio: "4/1" }}
      />
    </>
  );
};

export default VideoQuoteSection;
